import { Link } from 'react-router-dom';
import BlogLayout from '../blog/BlogLayout';
import SEO from '../components/SEO';
import { BreadcrumbStructuredData } from '../components/StructuredData';
import { comparisons } from './registry';

const SITE_URL = 'https://www.greyfielddata.com';

export default function CompareIndex() {
  const bi = comparisons.filter((page) => page.group === 'bi');
  const ecomm = comparisons.filter((page) => page.group === 'ecomm');

  return (
    <BlogLayout wide>
      <SEO
        title="Sigma and ecommerce reporting comparisons"
        description="Honest comparisons of Sigma against Tableau, Power BI, Looker, and others, and of custom ecommerce warehouses against Triple Whale, Polar, and other packaged tools."
        url={`${SITE_URL}/compare`}
      />
      <BreadcrumbStructuredData
        items={[
          { name: 'Home', url: SITE_URL },
          { name: 'Comparisons', url: `${SITE_URL}/compare` },
        ]}
      />
      <header className="max-w-3xl border-b border-slate-200 pb-8">
        <h1 className="text-4xl font-semibold leading-tight tracking-tight text-slate-950 sm:text-5xl">Comparisons</h1>
        <p className="mt-5 text-lg leading-relaxed text-slate-600">
          We sell Sigma and custom warehouse work, so read these knowing that. We still say where the other option is better, link every claim to the page we checked, and fix mistakes when a vendor tells us about them.
        </p>
      </header>

      {[
        { heading: 'Sigma vs other BI tools', intro: 'For teams on Snowflake, BigQuery, or Databricks choosing a BI layer.', pages: bi },
        { heading: 'Custom warehouse vs packaged ecommerce reporting', intro: 'For brands deciding between an off-the-shelf analytics app and a warehouse built around their own sources.', pages: ecomm },
      ].map((group) => (
        <section key={group.heading} className="mt-12">
          <h2 className="text-2xl font-semibold text-slate-950">{group.heading}</h2>
          <p className="mt-2 text-slate-600">{group.intro}</p>
          <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {group.pages.map((page) => (
              <Link key={page.slug} to={`/compare/${page.slug}`} className="group rounded-2xl border border-gray-200 bg-white p-6 transition hover:-translate-y-0.5 hover:border-blue-200 hover:shadow-lg">
                <h3 className="text-lg font-semibold leading-snug text-gray-900 group-hover:text-[#1a4e94]">{page.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-600">{page.description}</p>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </BlogLayout>
  );
}
